import React, { useContext } from 'react'
import { ListGroup } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { ConfigContext } from 'contexts/ConfigContext'
import objectPath from 'object-path'

const FormBreadcrumb = ({ match, item, main }) => {
  let matchPage = match
  const configContext = useContext(ConfigContext)
  const { perspective, designName } = configContext.state
  let formCode = objectPath.get(matchPage, 'params.formCode') || ''
  let url = `${perspective.routePath}/display/form/${formCode}`

  return (
    <ListGroup as="ul" bsPrefix=" " className="breadcrumb">
      <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item">
        <Link to="/">
          <i className="feather icon-home" />
        </Link>
      </ListGroup.Item>
      <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item">
        {main.title}
      </ListGroup.Item>
      <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item">
        {item.title}
      </ListGroup.Item>
      <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item">
        {designName}
      </ListGroup.Item>
    </ListGroup>
  )
}

export default FormBreadcrumb
